import { realtimeDb, firestoreDb, firebaseAuth } from '../config/constants'
import firebase from 'firebase';
import log from '../helpers/logger'

export function getD2hPublishMagazineList(){

  let dataList = []
  return firestoreDb.collection("d2hpublishmagazine").get().then(function(querySnapshot) {
    let count = 0;
    querySnapshot.forEach(function(doc) {
        //console.log(doc.id, " => ", doc.data());
        dataList.push(doc)
        count = count+1
        if(count === querySnapshot.size){
          return dataList
        }
    });
  }).then(() => dataList);
}

export function getD2hPublishMagazineListNotDeleted(){

  let dataList = []
  return firestoreDb.collection("d2hpublishmagazine").get().then(function(querySnapshot) {
    let count = 0;
    querySnapshot.forEach(function(doc) {
        //console.log(doc.id, " => ", doc.data());
        if(doc.data().status !== 'D'){
          dataList.push(doc)
        }

        count = count+1
        if(count === querySnapshot.size){
          return dataList
        }
    });
  }).then(() => dataList);
}

// export function getD2hPublishMagazineListNotDeleted(){
//
//   let dataList = []
//   var fRef = firestoreDb.collection("d2hpublishmagazine")
//   var query = fRef.where("status", "==", 'A')
//
//   return query.get().then(function(querySnapshot) {
//     let count = 0;
//     querySnapshot.forEach(function(doc) {
//         //console.log(doc.id, " => ", doc.data());
//         dataList.push(doc)
//         count = count+1
//         if(count === querySnapshot.size){
//           return dataList
//         }
//     });
//   }).then(() => dataList);
// }

export function updateD2hPublishMagazine (id, d2hpublishmagazine) {
  return firestoreDb.collection("d2hpublishmagazine").doc(id).update({

    issue_id: d2hpublishmagazine.issue_id,
    issue_uuid: d2hpublishmagazine.issue_uuid,
    magazine_id: d2hpublishmagazine.magazine_id,
    magazine_uuid: d2hpublishmagazine.magazine_uuid,
    title: d2hpublishmagazine.title,
    description: d2hpublishmagazine.description,
    book_download_url: d2hpublishmagazine.book_download_url,
    download_success_msg_body: d2hpublishmagazine.download_success_msg_body,
    download_success_msg_title: d2hpublishmagazine.download_success_msg_title,
    notify_cover_number: d2hpublishmagazine.notify_cover_number,
    notify_when: d2hpublishmagazine.notify_when,
    date_created: d2hpublishmagazine.date_created,
    status: d2hpublishmagazine.status,
    }).then(() => d2hpublishmagazine)
}

export function getD2hPublishMagazine (id) {

  return firestoreDb.collection("d2hpublishmagazine").doc(id).get().then(function(doc) {
    if (doc.exists) {
        return doc.data();
    } else {
        return null
    }
  });

}

export function deleteD2hPublishMagazine (id) {
  let d2hpublishmagazine = null
  return firestoreDb.collection("d2hpublishmagazine").doc(id).update({
    status: 'D'
    }).then(() => d2hpublishmagazine)
}

export function createD2hPublishMagazine (d2hpublishmagazine) {
  //setup date_created from firebase server.
  d2hpublishmagazine.date_created = firebase.firestore.FieldValue.serverTimestamp()

  return firestoreDb.collection("d2hpublishmagazine").add({

    issue_id: d2hpublishmagazine.issue_id,
    issue_uuid: d2hpublishmagazine.issue_uuid,
    magazine_id: d2hpublishmagazine.magazine_id,
    magazine_uuid: d2hpublishmagazine.magazine_uuid,
    title: d2hpublishmagazine.title,
    description: d2hpublishmagazine.description,
    book_download_url: d2hpublishmagazine.book_download_url,
    download_success_msg_body: d2hpublishmagazine.download_success_msg_body,
    download_success_msg_title: d2hpublishmagazine.download_success_msg_title,
    notify_cover_number: d2hpublishmagazine.notify_cover_number,
    notify_when: d2hpublishmagazine.notify_when,
    date_created: d2hpublishmagazine.date_created,
    status: d2hpublishmagazine.status,
    }).then(() => d2hpublishmagazine)

}



// WEBPACK FOOTER //
// ./src/services/D2hPublishMagazineService.js